import React, { Component } from 'react'
import { Popover, Modal, Input, Button, Upload, Icon } from 'antd'
import { app, api, config } from '../../../../app'

import html2canvas from 'html2canvas';



class PersonalInformation extends Component {
    // 组件内部
    constructor(props) {
        super(props)
        let data = {
            "org": "",
            "reg_name": "",
            "reg_auth": "",
            "unit": "",
            "code": "",
            "lar": "",
            "brank": "",
            "account": "",
            "name": "",
            "sex": "",
            "nation": "",
            "birth": "",
            "political_status": "",
            "teamposition": "",
            "address": "",
            "domicile": "",
            "idno": "",
            "bsr_dis_no": "",
            "mobile1": "",
            "urgent_contact": "",
            "education": "",
            "school": "",
            "graduation_time": "",
            "major": "",
            "family": [{
                "relation": "",
                "name": "",
                "work_unit": "",
                "mobile": ""
            }, {
                "relation": "",
                "name": "",
                "work_unit": "",
                "mobile": ""
            }, {
                "relation": "",
                "name": "",
                "work_unit": "",
                "mobile": ""
            }],
            "work_unit": "",
            "work_nature": "",
            "work_is_lar": "",
            "work_position": "",
            "entry_years": "",
            "work_years": "",
            "skill": "",
            "partner_gov": "",
            "religion": "",
            "join_years": "",
            "political_identity": "",
            "passport_no": "",
            "passport_vail": "",
            "mobile2": "",
            "email": "",
            "work_title": "",
            "work_exper": [{
                "name": "",
                "nature": "",
                "position": "",
                "join_time": ""
            }, {
                "name": "",
                "nature": "",
                "position": "",
                "join_time": ""
            }, {
                "name": "",
                "nature": "",
                "position": "",
                "join_time": ""
            }, {
                "name": "",
                "nature": "",
                "position": "",
                "join_time": ""
            }, {
                "name": "",
                "nature": "",
                "position": "",
                "join_time": ""
            }],
            "prize": [{
                "unit": "",
                "name": "",
                "year": ""
            }, {
                "unit": "",
                "name": "",
                "year": ""
            }, {
                "unit": "",
                "name": "",
                "year": ""
            }, {
                "unit": "",
                "name": "",
                "year": ""
            }, {
                "unit": "",
                "name": "",
                "year": ""
            }, {
                "unit": "",
                "name": "",
                "year": ""
            }]
        }
        let uploadImgList = []
        let whiteOK = false
        if(props.fileInfo.length <=0){

        }else if(props.fileInfo[2].data != undefined){
            if (props.fileInfo[2].data.org != undefined) {
                data = props.fileInfo[2].data
    
                let familyInfo = {
                    "relation": "",
                    "name": "",
                    "work_unit": "",
                    "mobile": ""
                }
                let work_experInfo = {
                    "name": "",
                    "nature": "",
                    "position": "",
                    "join_time": ""
                }
                let prizeInfo = {
                    "unit": "",
                    "name": "",
                    "year": ""
                }
                // work_exper
                // prize
    
    
                // console.log(data.prize.length)
    
                for (let i = 1; i = 3 - data.family.length; i++) {
                    data.family.push(familyInfo)
                }
                for (let i = 1; i = 5 - data.work_exper.length; i++) {
                    data.work_exper.push(work_experInfo)
                }
                for (let i = 1; i = 6 - data.prize.length; i++) {
                    data.prize.push(prizeInfo)
                }
                whiteOK = true
                this.props.personal_file_json(data, 'data')
                if (props.fileInfo[2].img != undefined && props.fileInfo[2].img != '') {
                    uploadImgList = props.fileInfo[2].img.split(';;;')
                    this.props.personal_file_json(uploadImgList, 'img')
    
                }
            }
        } 
        


        if (props.com3.data != undefined && props.com3.data.org != undefined) {
            data = props.com3.data
            if (props.com3.img != '') {
                uploadImgList = props.com3.img.split(';;;')
            }
        }

        this.state = {
            fileInfo: props.fileInfo,   //初始数据，一进入组件就请求获得

            isModalVisible: false,
            isModalVisible2: false,
            isModalVisible3: false,
            PersonalInformationModal: false,
            submitOK: false,
            defaultImgList: [],

            personalInformationImg: '',
            personalInformationImg2: '',

            data: data,


            uploadImgList: uploadImgList,
            showMoadlImg: '',
            imgModal: false,
            whiteOK: whiteOK,  //是否已经提交过内容
            whiteModal: false,    //是否打开 注册申请表 编辑窗口




        }
        // this.getDefaultImg()
        // this.getExamineInfo()
        // this.getApplyinfo()

    }

    componentDidMount() {
        this.getDefaultImg()
        this.getApplyinfo()
        this.getExamineInfo()

    }


    componentWillReceiveProps(nextProps) {
        if (nextProps.applyinfo !== this.props.applyinfo) {
            if (this.props.apply != 1) {
                return
            }
            // 值发生改变下一步工作
            // console.log("正在获取详情内容")
            const applyinfo = app.getData('applyinfo');
            let uploadImgList = this.state.uploadImgList;
            let data = applyinfo.file[2].data
            let familyInfo = {
                "relation": "",
                "name": "",
                "work_unit": "",
                "mobile": ""
            }
            let work_experInfo = {
                "name": "",
                "nature": "",
                "position": "",
                "join_time": ""
            }
            let prizeInfo = {
                "unit": "",
                "name": "",
                "year": ""
            }
            // work_exper
            // prize




            for (let i = 0; i = 3 - data.family.length; i++) {
                // console.log(i)
                data.family.push(familyInfo)
            }
            for (let i = 0; i = 5 - data.work_exper.length; i++) {
                data.work_exper.push(work_experInfo)
            }
            for (let i = 0; i = 6 - data.prize.length; i++) {
                data.prize.push(prizeInfo)
            }

            this.props.personal_file_json(data, 'data')
            uploadImgList = applyinfo.file[2].img.split(';;;')
            this.props.personal_file_json(uploadImgList, 'img')

            // console.log(data)
            console.log(data)
            this.setState({
                uploadImgList,
                data,
                whiteOK: true
            }, () => {
                console.log(this.state.uploadImgList)
            })
        }



        if (nextProps.examineInfo !== this.props.examineInfo) {
            // 值发生改变下一步工作
            if (this.props.examine != 1) {
                return
            }
            const examineInfo = app.getData('examineInfo');

            let uploadImgList = this.state.uploadImgList;
            uploadImgList = examineInfo.file[2].img.split(';;;')
            this.setState({
                uploadImgList
            })
        }
    }


    //对默认展示图片进行处理
    getDefaultImg = () => {
        if(this.props.fileInfo.length <=0){
            return
        }
        let defaultImgList = this.props.fileInfo[2].template_img.split(';;;')
        // console.log(defaultImgList)
        this.setState({
            defaultImgList: defaultImgList
        }, () => {
            console.log("已修改个人信息图片")
        })
    }

    getExamineInfo = () => {
        if (this.props.examine != 1) {
            return
        }
        const examineInfo = this.props.examineInfo;
        let uploadImgList = this.state.uploadImgList;
        uploadImgList = examineInfo.file[2].img.split(';;;')
        this.setState({
            uploadImgList
        })
    }

    getApplyinfo = () => {
        if (this.props.apply != 1) {
            return
        }
        // console.log("正在获取详情内容")
        const applyinfo = this.props.applyinfo;
        // console.log(applyinfo)
        let uploadImgList = this.state.uploadImgList;
        let data = applyinfo.file[2].data
        let familyInfo = {
            "relation": "",
            "name": "",
            "work_unit": "",
            "mobile": ""
        }
        let work_experInfo = {
            "name": "",
            "nature": "",
            "position": "",
            "join_time": ""
        }
        let prizeInfo = {
            "unit": "",
            "name": "",
            "year": ""
        }
        // work_exper
        // prize


        console.log(data)
        console.log(data.family.length)
        for (let i = 0; i = 3 - data.family.length; i++) {
            // console.log(i)
            data.family.push(familyInfo)
        }
        
        for (let i = 0; i = 5 - data.work_exper.length; i++) {
            data.work_exper.push(work_experInfo)
        }
        for (let i = 0; i = 6 - data.prize.length; i++) {
            data.prize.push(prizeInfo)
        }

        this.props.personal_file_json(data, 'data')
        uploadImgList = applyinfo.file[2].img.split(';;;')
        this.props.personal_file_json(uploadImgList, 'img')

        // console.log(data)
        console.log(data) 
        this.setState({
            uploadImgList,
            data,
            whiteOK: true
        }, () => {
            console.log(this.state.uploadImgList)
        })
    }

    showModal = () => {
        this.setState({
            isModalVisible: true
        })
    };

    handleCancel = () => {
        // console.log("点击取消");
        this.setState({
            isModalVisible: false
        })
    };










    ShutDownFill = () => {
        this.setState({
            PersonalInformationModal: false
        })
    }


    _changeValue = (e) => {
        let reg = /\d/;
        let { data } = this.state,dataIndex = e.target.getAttribute("data-num")

        // console.log(e.target.getAttribute("data-num"))
        // 如果有数字那么就循环数据
        
        if (reg.test(dataIndex)) {
            let a = data[e.target.name]
            // a.map((item, index) => {
            //     if (dataIndex == index) {
            //         item[e.target.getAttribute("data-sub")] = e.target.value.trim()
            //     }
            // })
            // console.log(a)
            // data[e.target.name][dataIndex][e.target.getAttribute("data-sub")][]
            data[e.target.name][dataIndex][e.target.getAttribute("data-sub")] = e.target.value.trim()
            // console.log(data[e.target.name][dataIndex][e.target.getAttribute("data-sub")])

            // for(let i =0; i < a.length -1; i++){
            //     if (dataIndex == i) {
            //         // item[e.target.getAttribute("data-sub")] = e.target.value.trim()
            //         console.log(a[i][e.target.getAttribute("data-sub")])
            //         a[i][e.target.getAttribute("data-sub")] = e.target.value.trim()
            //         console.log(i)
            //         this.setState({
            //             data
            //         })
            //         return
            //     }
            // }
            
        } else {
            // console.log(2)
            data[e.target.name] = e.target.value.trim()
        }
        this.setState({
            data
        })
    }

    submit = () => {
        let info = this.state.data;

        if (info.org == '') {
            app.alert('品牌使用组织未填写', 'error', '45%')
            return
        }
        if (info.reg_name == '') {
            app.alert('注册登记名称未填写', 'error', '45%')
            return
        }
        if (info.reg_auth == '') {
            app.alert('登记机关未填写', 'error', '45%')
            return
        }
        if (info.unit == '') {
            app.alert('主管单位未填写', 'error', '45%')
            return
        }

        if (info.code == '') {
            app.alert('全国统一代码未填写', 'error', '45%')
            return
        }

        if (info.lar == '') {
            app.alert('法定代表人未填写', 'error', '45%')
            return
        }

        if (info.brank == '') {
            app.alert('开户银行未填写', 'error', '45%')
            return
        }

        if (info.account == '') {
            app.alert('账号未填写', 'error', '45%')
            return
        }

        if (info.name == '') {
            app.alert('姓名未填写', 'error', '45%')
            return
        }

        if (info.sex == '') {
            app.alert('性别未填写', 'error', '45%')
            return
        }

        if (info.nation == '') {
            app.alert('民族未填写', 'error', '45%')
            return
        }

        if (info.birth == '') {
            app.alert('出生年月未填写', 'error', '45%')
            return
        }

        if (info.political_status == '') {
            app.alert('政治面貌未填写', 'error', '45%')
            return
        }

        if (info.teamposition == '') {
            app.alert('存心救援内担任职务未填写', 'error', '45%')
            return
        }

        if (info.address == '') {
            app.alert('现常居住址未填写', 'error', '45%')
            return
        }

        if (info.domicile == '') {
            app.alert('户籍所在地未填写', 'error', '45%')
            return
        }

        if (info.idno == '') {
            app.alert('身份证号码未填写', 'error', '45%')
            return
        }

        if (info.bsr_dis_no == '') {
            app.alert('存心救援识别号未填写', 'error', '45%')
            return
        }

        if (info.mobile1 == '') {
            app.alert('联系电话1未填写', 'error', '45%')
            return
        }

        if (info.urgent_contact == '') {
            app.alert('紧急联系人及电话未填写', 'error', '45%')
            return
        }

        if (info.education == '') {
            app.alert('最终学历未填写', 'error', '45%')
            return
        }

        if (info.school == '') {
            app.alert('毕业院校未填写', 'error', '45%')
            return
        }

        if (info.graduation_time == '') {
            app.alert('毕业时间未填写', 'error', '45%')
            return
        }

        if (info.major == '') {
            app.alert('所学专业未填写', 'error', '45%')
            return
        }




        // family
        if (info.family[0].relation == '' && info.family[0].name == '' && info.family[0].work_unit == '' && info.family[0].mobile == '') {
            app.alert('至少填写一位家庭成员基本信息/请逐行填写', 'error', '45%')
            return
        }

        if (info.family[0].relation == '') {
            app.alert('家庭成员与本人关系未填写', 'error', '45%')
            return
        }

        if (info.family[0].name == '') {
            app.alert('家庭成员姓名未填写', 'error', '45%')
            return
        }

        if (info.family[0].work_unit == '') {
            app.alert('家庭成员工作/学习单位未填写', 'error', '45%')
            return
        }

        if (info.family[0].mobile == '') {
            app.alert('家庭成员联系方式未填写', 'error', '45%')
            return
        }








        if (info.work_unit == '') {
            app.alert('工作单位未填写', 'error', '45%')
            return
        }

        if (info.work_nature == '') {
            app.alert('机构性质未填写', 'error', '45%')
            return
        }
        if (info.work_is_lar == '') {
            app.alert('是否担任法人未填写', 'error', '45%')
            return
        }
        if (info.work_position == '') {
            app.alert('所任岗位/职务未填写', 'error', '45%')
            return
        }

        if (info.entry_years == '') {
            app.alert('入职年限未填写', 'error', '45%')
            return
        }

        if (info.work_years == '') {
            app.alert('工作年限未填写', 'error', '45%')
            return
        }

        if (info.skill == '') {
            app.alert('个人专业技术资格、技能、专业培训未填写', 'error', '45%')
            return
        }
        this.props.personal_file_json(info, 'data')
        this.setState({
            PersonalInformationModal: false,
            whiteOK: true
        })
    }

















    // {/* 存心救援队注册申请表 */}
    clickImg = (i) => {
        this.setState({
            imgModal: true,
            showMoadlImg: i.target.getAttribute('data-img')
        })
    };

    deleImg = (i) => {
        const { uploadImgList } = this.state;
        uploadImgList.splice(i, 1)
        // this.props.deleteImg_personal_file_json(i)
        this.props.personal_file_json(uploadImgList, 'img')

        this.setState({
            uploadImgList
        })
    };


    clickImgCencel = () => {
        this.setState({
            imgModal: false
        })
    };



    white = () => {
        this.setState({
            PersonalInformationModal: true,
        })
    }

    closeWhite = () => {
        this.setState({
            whiteModal: false
        })
    }

    downLoad = (blobUrl) => {
        const data = this.state.data;
        // console.log(data)
        if (data.family[2].relation == '' || data.family[2].name == '' || data.family[2].work_unit == '' || data.family[2].mobile == '') {
            data.family.splice(-1, 1)
        }

        if (data.family[1].relation == '' || data.family[1].name == '' || data.family[1].work_unit == '' || data.family[1].mobile == '') {
            data.family.splice(-1, 1)
        }





        if (data.work_exper[1].name == '' || data.work_exper[1].nature == '' || data.work_exper[1].position == '' || data.work_exper[1].join_time == '') {
            data.work_exper.splice(-1, 1)
        }

        if (data.work_exper[0].name == '' || data.work_exper[0].nature == '' || data.work_exper[0].position == '' || data.work_exper[0].join_time == '') {
            data.work_exper.splice(-1, 1)
        }


        if (data.prize[2].unit == '' || data.prize[2].name == '' || data.prize[2].year == '') {
            data.prize.splice(-1, 1)
        }

        if (data.prize[1].unit == '' || data.prize[1].name == '' || data.prize[1].year == '') {
            data.prize.splice(-1, 1)
        }

        if (data.prize[0].unit == '' || data.prize[0].name == '' || data.prize[0].year == '') {
            data.prize.splice(-1, 1)
        }
        
        let that = this;
        let xhr = new XMLHttpRequest()
        xhr.open('POST', config.serverUrl + '/TeamPrep/getFilePdf', true)
        xhr.responseType = 'blob'
        let fd = new FormData();
        fd.append("key", 'personal');
        fd.append("file_data", JSON.stringify(data));
        xhr.send(fd);
        xhr.onload = function () {
            if (this.status == 200) {
                let blob = this.response
                // console.log(blob)
                that.downloadFile1(blob, 'pdf', '个人信息表.pdf');
            }
        }
    }

    downloadFile1(data, type, fileName) {
        const info = this.state.data;

        let familyInfo = {
            "relation": "",
            "name": "",
            "work_unit": "",
            "mobile": ""
        }
        let work_experInfo = {
            "name": "",
            "nature": "",
            "position": "",
            "join_time": ""
        }
        let prizeInfo = {
            "unit": "",
            "name": "",
            "year": ""
        }
        // work_exper
        // prize


        // console.log(data.prize.length)

        for (let i = 1; i = 3 - info.family.length; i++) {
            info.family.push(familyInfo)
        }
        for (let i = 1; i = 5 - info.work_exper.length; i++) {
            info.work_exper.push(work_experInfo)
        }
        for (let i = 1; i = 6 - info.prize.length; i++) {
            info.prize.push(prizeInfo)
        }
        this.setState({
            data:info
        })
        let blob = new Blob([data], { type: `application/${type};charset=utf-8` });
        // console.log(123)
        // 获取heads中的filename文件名
        let downloadElement = document.createElement('a');
        // 创建下载的链接
        let href = window.URL.createObjectURL(blob);
        downloadElement.href = href;
        // 下载后文件名
        downloadElement.download = fileName;
        document.body.appendChild(downloadElement);
        // 点击下载
        downloadElement.click();
        // 下载完成移除元素
        document.body.removeChild(downloadElement);
        // 释放掉blob对象
        window.URL.revokeObjectURL(href);


    }



    downloadJPG = async (DOMId, fileName) => {
        let ppg = document.getElementById(DOMId);

        html2canvas(ppg, {
            allowTaint: false,
            useCORS: true,
        }).then(canvas => {
            // toImage
            const dataImg = new Image()
            dataImg.src = canvas.toDataURL('image/png')
            const alink = document.createElement("a");
            alink.href = dataImg.src;
            alink.download = fileName + ".png";
            alink.click();
            this.setState({
                whiteModal: false
            })
        });
    }

    uploadImg = (info) => {
        if(info.file.status === 'uploading'){
            let flag = true
            this.props.uploadImgLoading(flag)
            return
        }
        if (info.file.status === 'done') {
            const res = info.file.response
            if (res.flag === 1) {
                // console.log(res)
                app.alert(res.msg, 'success', '45%')
                // 将数据返回给父组件

                // let img = res.data.url;

                const { uploadImgList } = this.state;
                uploadImgList.push(res.data.url)
                // 当上传图片完成后将返回的图片放到本地以备用户预览
                this.props.personal_file_json(uploadImgList, 'img')
                this.setState({
                    uploadImgList
                },()=>{
                    let flag = false
                    this.props.uploadImgLoading(flag)
                })
            } else {
                app.alert(res.msg, 'error', '45%')

            }
        }
    }

    lastImg = () => {
        let showMoadlImg = this.state.showMoadlImg;
        const { uploadImgList, defaultImgList } = this.state;
        let index
        if (uploadImgList.length < 1) {
            //如果用户没有上传图片，那么点击图片预览的是模版图片
            this.props.fileInfo[2].template_img.split(';;;').forEach((i, v) => {
                if (i == showMoadlImg) {
                    if (v == 0) {
                        index = v
                        app.alert("没有更多图片了", 'error', '45%')
                        return
                    } else {
                        index = v
                    }
                }
            })
            if (index == 0) {
                return
            } else {
                showMoadlImg = this.props.fileInfo[2].template_img.split(';;;')[index - 1]
                this.setState({
                    showMoadlImg
                })
            }
        } else {
            //如果用户上传了图片，那么点击图片预览的是上传图片
            uploadImgList.forEach((i, v) => {
                if (i == showMoadlImg) {
                    if (v == 0) {
                        index = v
                        app.alert("没有更多图片了", 'error', '45%')
                        return
                    } else {
                        index = v
                    }
                }
            })
            if (index == 0) {
                return
            } else {
                showMoadlImg = uploadImgList[index - 1]
                this.setState({
                    showMoadlImg
                })
            }
        }


    }

    nextImg = () => {
        let showMoadlImg = this.state.showMoadlImg;
        const { uploadImgList, defaultImgList } = this.state;
        let index
        if (uploadImgList.length < 1) {
            this.props.fileInfo[2].template_img.split(';;;').forEach((i, v) => {
                if (i == showMoadlImg) {
                    if (v == 2 || v == this.props.fileInfo[2].template_img.split(';;;').length - 1) {
                        index = v
                        app.alert("没有更多图片了", 'error', '45%')
                        return
                    } else {
                        index = v
                    }
                }
            })
            if (index == 2 || index == this.props.fileInfo[2].template_img.split(';;;').length - 1) {
                return
            } else {
                showMoadlImg = this.props.fileInfo[2].template_img.split(';;;')[index + 1]
                this.setState({
                    showMoadlImg
                })
            }
        } else {
            uploadImgList.forEach((i, v) => {
                if (i == showMoadlImg) {
                    if (v == 2 || v == uploadImgList.length - 1) {
                        index = v
                        app.alert("没有更多图片了", 'error', '45%')
                        return
                    } else {
                        index = v
                    }
                }
            })
            if (index == 2 || index == uploadImgList.length - 1) {
                return
            } else {
                showMoadlImg = uploadImgList[index + 1]
                this.setState({
                    showMoadlImg
                })
            }
        }


    }





    // 页面渲染区
    render() {
        let { fileInfo, defaultImgList, uploadImgList, data } = this.state
        const content = (
            <div>
                <p>点击可预览模板</p>
            </div>
        )

        const imgList = uploadImgList.map((item, index) => {
            return (
                <Popover key={item} content={
                    <div >
                        <p style={{ marginBottom: 20, cursor: 'pointer' }} onClick={this.clickImg} data-img={item}>预览</p>
                        {
                            this.props.examine == 1 || this.props.detailF == 1 ? '' :
                                <p style={{ cursor: 'pointer' }} onClick={() => this.deleImg(index)}>删除</p>

                        }
                    </div>
                }>

                    <img style={{ width: 90, height: 100, marginRight: 5 }} key={item} src={config.imgUrl + item} alt="" />
                </Popover>

            )
        })
        
            const defaultImg = (this.props.fileInfo.length <= 0 ? [] : this.props.fileInfo[2].template_img.split(';;;')).map((item, index) => {
                return (
                    <Popover key={item} content={
                        <div >
                            <p style={{ marginBottom: 20, cursor: 'pointer' }} onClick={this.clickImg} data-img={item}>预览模板</p>
                        </div>
                    }>
                        <img style={{ width: 90, height: 100, marginRight: 5 }} key={item} src={config.imgUrl + item} alt="" />
                    </Popover>
    
                )
            })
            
        
        return (
            <div >
                <div style={{ width: 400, height: 200, borderWidth: 1, borderStyle: 'solid', borderColor: '#000' }}>
                    {/* 标题 */}
                    <p style={{ fontSize: 16, color: '#1890FF', paddingTop: 15, paddingLeft: 10 }}>
                        <Popover content={content}>
                            <span style={{ cursor: 'pointer' }} onClick={this.showModal}>《个人信息表》</span>
                        </Popover>

                        <Modal title="个人信息表" visible={this.state.isModalVisible} width={1200} style={{ display: 'flex', justifyContent: 'center' }} footer={null} onCancel={this.handleCancel}>
                            {
                                (this.props.fileInfo.length <= 0 ? [] : this.props.fileInfo[2].template_img.split(';;;')).map((item, index) => {
                                    return (

                                        <img style={{ width: 1150, marginRight: 5,borderBottom:3,borderBottomStyle:'solid',borderBottomColor:'#ddd' }} key={item} src={config.imgUrl + item} alt="" />

                                    )
                                })
                            }
                        </Modal>

                    </p>
                    {/* 标题end */}

                    {/* 资料框 */}


                    <div style={{ display: 'flex', justifyContent: 'space-around' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-around', width: '80%' }}>

                            <div style={{ cursor: 'pointer', overflowX: 'auto', whiteSpace: 'nowrap', padding: 3 }}>
                                {
                                    uploadImgList.length < 1
                                        ?
                                        defaultImg
                                        :
                                        imgList
                                }

                            </div>


                            <Modal title="个人信息表" visible={this.state.imgModal} width={1200} style={{ display: 'flex', justifyContent: 'center' }} footer={null} onCancel={this.clickImgCencel}>
                                <p style={{ display: 'flex', justifyContent: 'space-around', color: '#1890ff', fontWeight: 'bold' }}>
                                    <div style={{ cursor: 'pointer' }} onClick={this.lastImg}>
                                        <Icon type="left" ></Icon> 上一张
                                    </div>
                                    <div style={{ cursor: 'pointer' }} onClick={this.nextImg}>
                                        下一张<Icon type="right" ></Icon>
                                    </div>
                                </p>
                                {

                                    <img src={config.imgUrl + this.state.showMoadlImg} alt="" style={{ width: 1000 }} />
                                }
                            </Modal>


                        </div>
                        {
                            this.props.examine == 1 || this.props.detailF == 1 ? '' : !this.state.whiteOK
                                ?
                                <div >
                                    <div style={{ cursor: 'pointer', color: '#1890FF' }} onClick={this.white}>填写</div>
                                    <div style={{ marginTop: 5 }}>下载</div>
                                    <div style={{ marginTop: 5 }} >上传</div>
                                </div>
                                :
                                <div >
                                    <div style={{ marginTop: 5, cursor: 'pointer', color: '#1890FF' }} onClick={this.white}>编辑</div>
                                    <div style={{ marginTop: 5, cursor: 'pointer', color: '#1890FF' }} onClick={this.downLoad}>
                                        下载
                                        </div>


                                    {uploadImgList.length == 3
                                        ?
                                        <div style={{ marginTop: 5 }} >上传</div>
                                        :
                                        <div style={{ marginTop: 5, cursor: 'pointer', color: '#1890FF' }} >
                                            <Upload
                                                accept='image/jpeg, image/jpg, image/png'
                                                showUploadList={false}
                                                action={config.serverUrl + "/TeamApply/imageUpload"}
                                                name="image"
                                                onChange={this.uploadImg}
                                                style={{ color: '#1890FF' }}>上传</Upload>
                                        </div>}




                                </div>

                        }

                    </div>

                    {/* 资料框 */}

                    <Modal title="个人信息表" visible={this.state.PersonalInformationModal} width={1250} footer={null} onCancel={this.ShutDownFill}>
                        <div style={{ width: 1200, display: 'flex' }}>
                            {/* 展示栏 */}
                            <div style={{ width: 1200, paddingTop: 70, paddingBottom: 120, fontSize: 22 }} >



                                <p style={{textAlign:'center',color:'#fb7a70'}}>注：存心救援品牌授权机构基本信息尚未注册登记的，可填 暂无</p>


                                <div id="JPGDOM" style={{ padding: 80, paddingTop: 100, paddingBottom: 1, }}>
                                    <p style={{ textAlign: 'center', fontSize: 34, }}>存心救援品牌主要管理者个人信息表</p>
                                    <div style={{ width: '100%', height: '85%', borderWidth: 1, borderStyle: 'solid', borderColor: '#000' }}>
                                        {/* 标题 */}
                                        <div style={{ textAlign: 'center', backgroundColor: '#D7D7D7', color: '#000', padding: 7, borderBottomStyle: 'solid', borderBottomColor: '#000', borderBottomWidth: 1 }}>存心救援品牌授权机构基本信息</div>
                                        {/* 标题 */}

                                        {/* 第1行 */}
                                        <div style={{ backgroundColor: '#D7D7D7', color: '#000', borderBottomColor: '#000', borderBottomWidth: 1, borderBottomStyle: 'solid', display: 'flex' }}>
                                            <div style={{ borderRightStyle: 'solid', borderRightColor: '#000', borderRightWidth: 1, padding: 7, textAlign: 'center', width: '16%' }}>
                                                <span style={{ color: 'red' }}>*</span>品牌使用组织
                                                </div>
                                            <div style={{ borderRightStyle: 'solid', borderRightColor: '#000', borderRightWidth: 1, width: '35%' }}>
                                                <input value={data.org} type="text" onChange={this._changeValue} name="org" style={{ outline: 'none', border: 0, width: '100%', height: '100%' }} />
                                            </div>

                                            <div style={{ borderRightStyle: 'solid', borderRightColor: '#000', borderRightWidth: 1, padding: 7, textAlign: 'center', width: '16%' }}>
                                                <span style={{ color: 'red' }}>*</span>注册登记名称
                                                </div>
                                            <div style={{ width: '35%' }}>
                                                <input value={data.reg_name} type="text" onChange={this._changeValue} name="reg_name" style={{ outline: 'none', border: 0, width: '100%', height: '100%' }} />
                                            </div>

                                        </div>
                                        {/* 第1行 */}

                                        {/* 第2行 */}

                                        <div style={{ backgroundColor: '#D7D7D7', color: '#000', borderBottomColor: '#000', borderBottomWidth: 1, borderBottomStyle: 'solid', display: 'flex' }}>
                                            <div style={{ borderRightStyle: 'solid', borderRightColor: '#000', borderRightWidth: 1, padding: 7, textAlign: 'center', width: '16%' }}>
                                                <span style={{ color: 'red' }}>*</span>登记机关
                                                </div>
                                            <div style={{ borderRightStyle: 'solid', borderRightColor: '#000', borderRightWidth: 1, width: '35%' }}>
                                                <input value={data.reg_auth} type="text" onChange={this._changeValue} name="reg_auth" style={{ outline: 'none', border: 0, width: '100%', height: '100%' }} />
                                            </div>

                                            <div style={{ borderRightStyle: 'solid', borderRightColor: '#000', borderRightWidth: 1, padding: 7, textAlign: 'center', width: '16%' }}>
                                                <span style={{ color: 'red' }}>*</span>主管单位
                                                </div>
                                            <div style={{ width: '35%' }}>
                                                <input value={data.unit} type="text" onChange={this._changeValue} name="unit" style={{ outline: 'none', border: 0, width: '100%', height: '100%' }} />
                                            </div>

                                        </div>
                                        {/* 第2行 */}

                                        {/* 第3行 */}

                                        <div style={{ backgroundColor: '#D7D7D7', color: '#000', borderBottomColor: '#000', borderBottomWidth: 1, borderBottomStyle: 'solid', display: 'flex' }}>
                                            <div style={{ borderRightStyle: 'solid', borderRightColor: '#000', borderRightWidth: 1, padding: 7, textAlign: 'center', width: '16%' }}>
                                                <span style={{ color: 'red' }}>*</span>全国统一代码
                                                </div>
                                            <div style={{ borderRightStyle: 'solid', borderRightColor: '#000', borderRightWidth: 1, width: '35%' }}>
                                                <input value={data.code} type="text" onChange={this._changeValue} name="code" style={{ outline: 'none', border: 0, width: '100%', height: '100%' }} />
                                            </div>

                                            <div style={{ borderRightStyle: 'solid', borderRightColor: '#000', borderRightWidth: 1, padding: 7, textAlign: 'center', width: '16%' }}>
                                                <span style={{ color: 'red' }}>*</span>法定代表人
                                                </div>
                                            <div style={{ width: '35%' }}>
                                                <input value={data.lar} type="text" onChange={this._changeValue} name="lar" style={{ outline: 'none', border: 0, width: '100%', height: '100%' }} />
                                            </div>

                                        </div>
                                        {/* 第3行 */}

                                        {/* 第4行 */}
                                        <div style={{ backgroundColor: '#D7D7D7', color: '#000', borderBottomColor: '#000', borderBottomWidth: 1, borderBottomStyle: 'solid', display: 'flex' }}>
                                            <div style={{ borderRightStyle: 'solid', borderRightColor: '#000', borderRightWidth: 1, padding: 7, textAlign: 'center', width: '16%' }}>
                                                <span style={{ color: 'red' }}>*</span>开户银行
                                                </div>
                                            <div style={{ borderRightStyle: 'solid', borderRightColor: '#000', borderRightWidth: 1, width: '35%' }}>
                                                <input value={data.brank} type="text" onChange={this._changeValue} name="brank" style={{ outline: 'none', border: 0, width: '100%', height: '100%' }} />
                                            </div>

                                            <div style={{ borderRightStyle: 'solid', borderRightColor: '#000', borderRightWidth: 1, padding: 7, textAlign: 'center', width: '16%' }}>
                                                <span style={{ color: 'red' }}>*</span>帐号
                                                </div>
                                            <div style={{ width: '35%' }}>
                                                <input value={data.account} type="text" onChange={this._changeValue} name="account" style={{ outline: 'none', border: 0, width: '100%', height: '100%' }} />
                                            </div>

                                        </div>
                                        {/* 第4行 */}


                                        {/* 第5行 */}
                                        <div style={{ backgroundColor: '#D7D7D7', color: '#000', borderBottomColor: '#000', borderBottomWidth: 1, borderBottomStyle: 'solid', display: 'flex' }}>
                                            <div style={{ borderRightStyle: 'solid', borderRightColor: '#000', borderRightWidth: 1, padding: 7, textAlign: 'center', width: '20%' }}>
                                                当地合作政府部门
                                                </div>
                                            <div style={{ width: '80%' }}>
                                                <input value={data.partner_gov} type="text" onChange={this._changeValue} name="partner_gov" style={{ outline: 'none', border: 0, width: '100%', height: '100%' }} />
                                            </div>

                                        </div>
                                        {/* 第5行 */}


                                        {/* 标题 */}
                                        <div style={{ textAlign: 'center', backgroundColor: '#D7D7D7', color: '#000', padding: 7, borderBottomStyle: 'solid', borderBottomColor: '#000', borderBottomWidth: 1 }}>存心救援品牌授权机构管理者个人基本信息</div>
                                        {/* 标题 */}

                                        {/* 第7行 */}

                                        <div style={{ display: 'flex', width: '100%' }}>

                                            <div style={{ width: '85%' }}>
                                                <div style={{ backgroundColor: '#D7D7D7', color: '#000', borderBottomColor: '#000', borderBottomWidth: 1, borderBottomStyle: 'solid', display: 'flex', width: '100%' }}>



                                                    <div style={{ borderRightStyle: 'solid', borderRightColor: '#000', borderRightWidth: 1, padding: 7, textAlign: 'center', width: '17%' }}>
                                                        <span style={{ color: 'red' }}>*</span>姓名
                                                            </div>
                                                    <div style={{ borderRightStyle: 'solid', borderRightColor: '#000', borderRightWidth: 1, width: '17%' }}>
                                                        <input value={data.name} type="text" onChange={this._changeValue} name="name" style={{ outline: 'none', border: 0, width: '100%', height: '100%' }} />
                                                    </div>

                                                    <div style={{ borderRightStyle: 'solid', borderRightColor: '#000', borderRightWidth: 1, padding: 7, textAlign: 'center', width: '17%' }}>
                                                        <span style={{ color: 'red' }}>*</span>性别
                                                            </div>
                                                    <div style={{ borderRightStyle: 'solid', borderRightColor: '#000', borderRightWidth: 1, width: '17%' }}>
                                                        <input value={data.sex} type="text" onChange={this._changeValue} name="sex" style={{ outline: 'none', border: 0, width: '100%', height: '100%' }} />
                                                    </div>

                                                    <div style={{ borderRightStyle: 'solid', borderRightColor: '#000', borderRightWidth: 1, padding: 7, textAlign: 'center', width: '17%' }}>
                                                        <span style={{ color: 'red' }}>*</span>民族
                                                            </div>
                                                    <div style={{ borderRightStyle: 'solid', borderRightColor: '#000', borderRightWidth: 1, width: '17%' }}>
                                                        <input value={data.nation} type="text" onChange={this._changeValue} name="nation" style={{ outline: 'none', border: 0, width: '100%', height: '100%' }} />
                                                    </div>



                                                </div>

                                                <div style={{ backgroundColor: '#D7D7D7', color: '#000', borderBottomColor: '#000', borderBottomWidth: 1, borderBottomStyle: 'solid', display: 'flex', width: '100%' }}>



                                                    <div style={{ borderRightStyle: 'solid', borderRightColor: '#000', borderRightWidth: 1, padding: 7, textAlign: 'center', width: '17%' }}>
                                                        <span style={{ color: 'red' }}>*</span>出生年月
                                                            </div>
                                                    <div style={{ borderRightStyle: 'solid', borderRightColor: '#000', borderRightWidth: 1, width: '17%' }}>
                                                        <input value={data.birth} type="text" onChange={this._changeValue} name="birth" style={{ outline: 'none', border: 0, width: '100%', height: '100%' }} />
                                                    </div>

                                                    <div style={{ borderRightStyle: 'solid', borderRightColor: '#000', borderRightWidth: 1, padding: 7, textAlign: 'center', width: '17%' }}>
                                                        <span style={{ color: 'red' }}>*</span>政治面貌
                                                            </div>
                                                    <div style={{ borderRightStyle: 'solid', borderRightColor: '#000', borderRightWidth: 1, width: '17%' }}>
                                                        <input value={data.political_status} type="text" onChange={this._changeValue} name="political_status" style={{ outline: 'none', border: 0, width: '100%', height: '100%' }} />
                                                    </div>

                                                    <div style={{ borderRightStyle: 'solid', borderRightColor: '#000', borderRightWidth: 1, padding: 7, textAlign: 'center', width: '17%' }}>
                                                        宗教信仰
                                                            </div>
                                                    <div style={{ borderRightStyle: 'solid', borderRightColor: '#000', borderRightWidth: 1, width: '17%' }}>
                                                        <input value={data.religion} type="text" onChange={this._changeValue} name="religion" style={{ outline: 'none', border: 0, width: '100%', height: '100%' }} />
                                                    </div>



                                                </div>


                                                <div style={{ backgroundColor: '#D7D7D7', color: '#000', borderBottomColor: '#000', borderBottomWidth: 1, borderBottomStyle: 'solid', display: 'flex', width: '100%' }}>



                                                    <div style={{ borderRightStyle: 'solid', borderRightColor: '#000', borderRightWidth: 1, padding: 7, textAlign: 'center', width: '16.66%' }}>
                                                        党员入党年份
                                                            </div>
                                                    <div style={{ borderRightStyle: 'solid', borderRightColor: '#000', borderRightWidth: 1, width: '16.66%' }}>
                                                        <input value={data.join_years} type="text" onChange={this._changeValue} name="join_years" style={{ outline: 'none', border: 0, width: '100%', height: '100%' }} />
                                                    </div>

                                                    <div style={{ borderRightStyle: 'solid', borderRightColor: '#000', borderRightWidth: 1, padding: 7, textAlign: 'center', width: '16.66%' }}>
                                                        政治身份
                                                            </div>
                                                    <div style={{ borderRightStyle: 'solid', borderRightColor: '#000', borderRightWidth: 1, width: '50%' }}>
                                                        <input value={data.political_identity} type="text" onChange={this._changeValue} name="political_identity" style={{ outline: 'none', border: 0, width: '100%', height: '100%' }} />
                                                    </div>





                                                </div>

                                                <div style={{ backgroundColor: '#D7D7D7', color: '#000', borderBottomColor: '#000', borderBottomWidth: 1, borderBottomStyle: 'solid', display: 'flex', width: '100%' }}>



                                                    <div style={{ borderRightStyle: 'solid', borderRightColor: '#000', borderRightWidth: 1, padding: 7, textAlign: 'center', width: '16.66%' }}>
                                                        <span style={{ color: 'red' }}>*</span>存心救援内担任职务
                                                            </div>
                                                    <div style={{ borderRightStyle: 'solid', borderRightColor: '#000', borderRightWidth: 1, width: '83.34%' }}>
                                                        <input value={data.teamposition} type="text" onChange={this._changeValue} name="teamposition" style={{ outline: 'none', border: 0, width: '100%', height: '100%' }} />
                                                    </div>

                                                </div>

                                            </div>

                                            <div style={{ width: '15%', backgroundColor: '#D7D7D7', borderBottomColor: '#000', borderBottomWidth: 1, borderBottomStyle: 'solid', textAlign: 'center', }}>
                                                <p style={{ color: 'red' }}>*</p>
                                                <p>照片</p>
                                                <p>请粘贴证件照片</p>
                                            </div>


                                        </div>

                                        {/* 第7行 */}

                                        {/* 第11行 */}
                                        <div style={{ backgroundColor: '#D7D7D7', color: '#000', borderBottomColor: '#000', borderBottomWidth: 1, borderBottomStyle: 'solid', display: 'flex' }}>
                                            <div style={{ borderRightStyle: 'solid', borderRightColor: '#000', borderRightWidth: 1, padding: 7, textAlign: 'center', width: '17%' }}>
                                                <span style={{ color: 'red' }}>*</span>现常居住址
                                                </div>
                                            <div style={{ borderRightStyle: 'solid', borderRightColor: '#000', borderRightWidth: 1, width: '35%' }}>
                                                <input value={data.address} type="text" onChange={this._changeValue} name="address" style={{ outline: 'none', border: 0, width: '100%', height: '100%' }} />
                                            </div>

                                            <div style={{ borderRightStyle: 'solid', borderRightColor: '#000', borderRightWidth: 1, padding: 7, textAlign: 'center', width: '15%' }}>
                                                <span style={{ color: 'red' }}>*</span>户籍所在地
                                                </div>
                                            <div style={{ width: '35%' }}>
                                                <input value={data.domicile} type="text" onChange={this._changeValue} name="domicile" style={{ outline: 'none', border: 0, width: '100%', height: '100%' }} />
                                            </div>

                                        </div>
                                        {/* 第11行 */}

                                        {/* 第12行 */}

                                        <div style={{ backgroundColor: '#D7D7D7', color: '#000', borderBottomColor: '#000', borderBottomWidth: 1, borderBottomStyle: 'solid', display: 'flex' }}>
                                            <div style={{ borderRightStyle: 'solid', borderRightColor: '#000', borderRightWidth: 1, padding: 7, textAlign: 'center', width: '17%' }}>
                                                <span style={{ color: 'red' }}>*</span>身份证号码
                                                </div>
                                            <div style={{ borderRightStyle: 'solid', borderRightColor: '#000', borderRightWidth: 1, width: '35%' }}>
                                                <input value={data.idno} type="text" onChange={this._changeValue} name="idno" style={{ outline: 'none', border: 0, width: '100%', height: '100%' }} />
                                            </div>

                                            <div style={{ borderRightStyle: 'solid', borderRightColor: '#000', borderRightWidth: 1, padding: 7, textAlign: 'center', width: '15%' }}>
                                                <span style={{ color: 'red' }}>*</span>存心救援识别号
                                                </div>
                                            <div style={{ width: '35%' }}>
                                                <input value={data.bsr_dis_no} type="text" onChange={this._changeValue} name="bsr_dis_no" style={{ outline: 'none', border: 0, width: '100%', height: '100%' }} />
                                            </div>

                                        </div>
                                        {/* 第12行 */}

                                        {/* 第13行 */}
                                        <div style={{ backgroundColor: '#D7D7D7', color: '#000', borderBottomColor: '#000', borderBottomWidth: 1, borderBottomStyle: 'solid', display: 'flex' }}>
                                            <div style={{ borderRightStyle: 'solid', borderRightColor: '#000', borderRightWidth: 1, padding: 7, textAlign: 'center', width: '17%' }}>
                                                护照号码
                                                </div>
                                            <div style={{ borderRightStyle: 'solid', borderRightColor: '#000', borderRightWidth: 1, width: '35%' }}>
                                                <input value={data.passport_no} type="text" onChange={this._changeValue} name="passport_no" style={{ outline: 'none', border: 0, width: '100%', height: '100%' }} />
                                            </div>

                                            <div style={{ borderRightStyle: 'solid', borderRightColor: '#000', borderRightWidth: 1, padding: 7, textAlign: 'center', width: '15%' }}>
                                                护照有效期
                                                </div>
                                            <div style={{ width: '35%' }}>
                                                <input value={data.passport_vail} type="text" onChange={this._changeValue} name="passport_vail" style={{ outline: 'none', border: 0, width: '100%', height: '100%' }} />
                                            </div>

                                        </div>
                                        {/* 第13行 */}


                                        {/* 第14行 */}
                                        <div style={{ backgroundColor: '#D7D7D7', color: '#000', borderBottomColor: '#000', borderBottomWidth: 1, borderBottomStyle: 'solid', display: 'flex' }}>
                                            <div style={{ borderRightStyle: 'solid', borderRightColor: '#000', borderRightWidth: 1, padding: 7, textAlign: 'center', width: '17%' }}>
                                                <span style={{ color: 'red' }}>*</span>联系电话1
                                                </div>
                                            <div style={{ borderRightStyle: 'solid', borderRightColor: '#000', borderRightWidth: 1, width: '35%' }}>
                                                <input value={data.mobile1} type="text" onChange={this._changeValue} name="mobile1" style={{ outline: 'none', border: 0, width: '100%', height: '100%' }} />
                                            </div>

                                            <div style={{ borderRightStyle: 'solid', borderRightColor: '#000', borderRightWidth: 1, padding: 7, textAlign: 'center', width: '15%' }}>
                                                电子邮箱
                                                </div>
                                            <div style={{ width: '35%' }}>
                                                <input value={data.email} type="text" onChange={this._changeValue} name="email" style={{ outline: 'none', border: 0, width: '100%', height: '100%' }} />
                                            </div>

                                        </div>
                                        {/* 第14行 */}

                                        {/* 第15行 */}
                                        <div style={{ backgroundColor: '#D7D7D7', color: '#000', borderBottomColor: '#000', borderBottomWidth: 1, borderBottomStyle: 'solid', display: 'flex' }}>
                                            <div style={{ borderRightStyle: 'solid', borderRightColor: '#000', borderRightWidth: 1, padding: 7, textAlign: 'center', width: '17%' }}>
                                                联系电话2
                                                </div>
                                            <div style={{ borderRightStyle: 'solid', borderRightColor: '#000', borderRightWidth: 1, width: '35%' }}>
                                                <input value={data.mobile2} type="text" onChange={this._changeValue} name="mobile2" style={{ outline: 'none', border: 0, width: '100%', height: '100%' }} />
                                            </div>

                                            <div style={{ borderRightStyle: 'solid', borderRightColor: '#000', borderRightWidth: 1, padding: 7, textAlign: 'center', width: '17%' }}>
                                                <span style={{ color: 'red' }}>*</span>紧急联系人及电话
                                                </div>
                                            <div style={{ width: '33%' }}>
                                                <input value={data.urgent_contact} type="text" onChange={this._changeValue} name="urgent_contact" style={{ outline: 'none', border: 0, width: '100%', height: '100%' }} />
                                            </div>

                                        </div>
                                        {/* 第15行 */}

                                        {/* 第16行 */}
                                        <div style={{ backgroundColor: '#D7D7D7', color: '#000', borderBottomColor: '#000', borderBottomWidth: 1, borderBottomStyle: 'solid', display: 'flex', width: '100%' }}>



                                            <div style={{ borderRightStyle: 'solid', borderRightColor: '#000', borderRightWidth: 1, padding: 7, textAlign: 'center', width: '16.66%' }}>
                                                <span style={{ color: 'red' }}>*</span>最终学历
                                                            </div>
                                            <div style={{ borderRightStyle: 'solid', borderRightColor: '#000', borderRightWidth: 1, width: '16.66%' }}>
                                                <input value={data.education} type="text" onChange={this._changeValue} name="education" style={{ outline: 'none', border: 0, width: '100%', height: '100%' }} />
                                            </div>

                                            <div style={{ borderRightStyle: 'solid', borderRightColor: '#000', borderRightWidth: 1, padding: 7, textAlign: 'center', width: '16.66%' }}>
                                                <span style={{ color: 'red' }}>*</span>毕业院校
                                                            </div>
                                            <div style={{ width: '50%' }}>
                                                <input value={data.school} type="text" onChange={this._changeValue} name="school" style={{ outline: 'none', border: 0, width: '100%', height: '100%' }} />
                                            </div>
                                        </div>
                                        {/* 第16行 */}


                                        {/* 第17行 */}
                                        <div style={{ backgroundColor: '#D7D7D7', color: '#000', borderBottomColor: '#000', borderBottomWidth: 1, borderBottomStyle: 'solid', display: 'flex', width: '100%' }}>



                                            <div style={{ borderRightStyle: 'solid', borderRightColor: '#000', borderRightWidth: 1, padding: 7, textAlign: 'center', width: '16.66%' }}>
                                                <span style={{ color: 'red' }}>*</span>毕业时间
                                                            </div>
                                            <div style={{ borderRightStyle: 'solid', borderRightColor: '#000', borderRightWidth: 1, width: '16.66%' }}>
                                                <input value={data.graduation_time} type="text" onChange={this._changeValue} name="graduation_time" style={{ outline: 'none', border: 0, width: '100%', height: '100%' }} />
                                            </div>

                                            <div style={{ borderRightStyle: 'solid', borderRightColor: '#000', borderRightWidth: 1, padding: 7, textAlign: 'center', width: '16.66%' }}>
                                                <span style={{ color: 'red' }}>*</span>所学专业
                                                            </div>
                                            <div style={{ width: '50%' }}>
                                                <input value={data.major} type="text" onChange={this._changeValue} name="major" style={{ outline: 'none', border: 0, width: '100%', height: '100%' }} />
                                            </div>
                                        </div>
                                        {/* 第17行 */}

                                        <div style={{ display: 'flex', width: '100%' }}>
                                            <div style={{ width: '15%', backgroundColor: '#D7D7D7', borderBottomColor: '#000', borderBottomWidth: 1, borderBottomStyle: 'solid', textAlign: 'center', borderRightStyle: 'solid', borderRightColor: '#000', borderRightWidth: 1, }}>
                                                <p style={{ color: 'red', margin: 0 }}>*</p>
                                                <p>家庭成员</p>
                                                <p>基本信息</p>
                                                
                                            </div>

                                            <div style={{ width: '85%' }}>
                                                <div style={{ backgroundColor: '#D7D7D7', color: '#000', borderBottomColor: '#000', borderBottomWidth: 1, borderBottomStyle: 'solid', display: 'flex', width: '100%' }}>



                                                    <div style={{ borderRightStyle: 'solid', borderRightColor: '#000', borderRightWidth: 1, padding: 7, textAlign: 'center', width: '23%' }}>
                                                        与本人关系
                                                            </div>


                                                    <div style={{ borderRightStyle: 'solid', borderRightColor: '#000', borderRightWidth: 1, padding: 7, textAlign: 'center', width: '23%' }}>
                                                        姓名
                                                            </div>


                                                    <div style={{ borderRightStyle: 'solid', borderRightColor: '#000', borderRightWidth: 1, padding: 7, textAlign: 'center', width: '31%' }}>
                                                        工作/学习单位
                                                            </div>


                                                    <div style={{ padding: 7, textAlign: 'center', width: '23%' }}>
                                                        联系方式
                                                            </div>




                                                </div>

                                                <div style={{ backgroundColor: '#D7D7D7', color: '#000', borderBottomColor: '#000', borderBottomWidth: 1, borderBottomStyle: 'solid', display: 'flex', width: '100%' }}>



                                                    <div style={{ borderRightStyle: 'solid', borderRightColor: '#000', borderRightWidth: 1, textAlign: 'center', width: '23%' }}>
                                                        <input value={data.family[0].relation} type="text" onChange={this._changeValue} name="family" data-num="0" data-sub="relation" style={{ outline: 'none', border: 0, width: '100%', height: '100%' }} />
                                                    </div>


                                                    <div style={{ borderRightStyle: 'solid', borderRightColor: '#000', borderRightWidth: 1, textAlign: 'center', width: '23%' }}>
                                                        <input value={data.family[0].name} type="text" onChange={this._changeValue} name="family" data-num="0" data-sub="name" style={{ outline: 'none', border: 0, width: '100%', height: '100%' }} />
                                                    </div>


                                                    <div style={{ borderRightStyle: 'solid', borderRightColor: '#000', borderRightWidth: 1, textAlign: 'center', width: '31%' }}>
                                                        <input value={data.family[0].work_unit} type="text" onChange={this._changeValue} name="family" data-num="0" data-sub="work_unit" style={{ outline: 'none', border: 0, width: '100%', height: '100%' }} />
                                                    </div>


                                                    <div style={{ textAlign: 'center', width: '23%' }}>
                                                        <input value={data.family[0].mobile} type="text" onChange={this._changeValue} name="family" data-num="0" data-sub="mobile" style={{ outline: 'none', border: 0, width: '100%', height: '100%' }} />
                                                    </div>



                                                </div>


                                                <div style={{ backgroundColor: '#D7D7D7', color: '#000', borderBottomColor: '#000', borderBottomWidth: 1, borderBottomStyle: 'solid', display: 'flex', width: '100%' }}>



                                                    <div style={{ borderRightStyle: 'solid', borderRightColor: '#000', borderRightWidth: 1, textAlign: 'center', width: '23%' }}>
                                                        <input value={data.family[1].relation} type="text" onChange={this._changeValue} name="family" data-num="1" data-sub="relation" style={{ outline: 'none', border: 0, width: '100%', height: '100%' }} />
                                                    </div>


                                                    <div style={{ borderRightStyle: 'solid', borderRightColor: '#000', borderRightWidth: 1, textAlign: 'center', width: '23%' }}>
                                                        <input value={data.family[1].name} type="text" onChange={this._changeValue} name="family" data-num="1" data-sub="name" style={{ outline: 'none', border: 0, width: '100%', height: '100%' }} />
                                                    </div>


                                                    <div style={{ borderRightStyle: 'solid', borderRightColor: '#000', borderRightWidth: 1, textAlign: 'center', width: '31%' }}>
                                                        <input value={data.family[1].work_unit} type="text" onChange={this._changeValue} name="family" data-num="1" data-sub="work_unit" style={{ outline: 'none', border: 0, width: '100%', height: '100%' }} />
                                                    </div>


                                                    <div style={{ textAlign: 'center', width: '23%' }}>
                                                        <input value={data.family[1].mobile} type="text" onChange={this._changeValue} name="family" data-num="1" data-sub="mobile" style={{ outline: 'none', border: 0, width: '100%', height: '100%' }} />
                                                    </div>





                                                </div>

                                                <div style={{ backgroundColor: '#D7D7D7', color: '#000', borderBottomColor: '#000', borderBottomWidth: 1, borderBottomStyle: 'solid', display: 'flex', width: '100%' }}>



                                                    <div style={{ borderRightStyle: 'solid', borderRightColor: '#000', borderRightWidth: 1, textAlign: 'center', width: '23%' }}>
                                                        <input value={data.family[2].relation} type="text" onChange={this._changeValue} name="family" data-num="2" data-sub="relation" style={{ outline: 'none', border: 0, width: '100%', height: '100%' }} />
                                                    </div>


                                                    <div style={{ borderRightStyle: 'solid', borderRightColor: '#000', borderRightWidth: 1, textAlign: 'center', width: '23%' }}>
                                                        <input value={data.family[2].name} type="text" onChange={this._changeValue} name="family" data-num="2" data-sub="name" style={{ outline: 'none', border: 0, width: '100%', height: '100%' }} />
                                                    </div>


                                                    <div style={{ borderRightStyle: 'solid', borderRightColor: '#000', borderRightWidth: 1, textAlign: 'center', width: '31%' }}>
                                                        <input value={data.family[2].work_unit} type="text" onChange={this._changeValue} name="family" data-num="2" data-sub="work_unit" style={{ outline: 'none', border: 0, width: '100%', height: '100%' }} />
                                                    </div>


                                                    <div style={{ textAlign: 'center', width: '23%' }}>
                                                        <input value={data.family[2].mobile} type="text" onChange={this._changeValue} name="family" data-num="2" data-sub="mobile" style={{ outline: 'none', border: 0, width: '100%', height: '100%' }} />
                                                    </div>

                                                </div>

                                            </div>




                                        </div>




                                        <div style={{ display: 'flex', width: '100%' }}>
                                            <div style={{ width: '15%', backgroundColor: '#D7D7D7', borderBottomColor: '#000', borderBottomWidth: 1, borderBottomStyle: 'solid', textAlign: 'center', borderRightStyle: 'solid', borderRightColor: '#000', borderRightWidth: 1, paddingTop: 75 }}>
                                                <p>专职工作</p>
                                            </div>

                                            <div style={{ width: '85%' }}>
                                                <div style={{ backgroundColor: '#D7D7D7', color: '#000', borderBottomColor: '#000', borderBottomWidth: 1, borderBottomStyle: 'solid', display: 'flex', width: '100%' }}>



                                                    <div style={{ borderRightStyle: 'solid', borderRightColor: '#000', borderRightWidth: 1, padding: 7, textAlign: 'center', width: '23%' }}>
                                                        <span style={{ color: 'red' }}>*</span>工作单位
                                                            </div>


                                                    <div style={{ textAlign: 'center', width: '77%' }}>
                                                        <input value={data.work_unit} type="text" onChange={this._changeValue} name="work_unit" style={{ outline: 'none', border: 0, width: '100%', height: '100%' }} />
                                                    </div>







                                                </div>

                                                <div style={{ backgroundColor: '#D7D7D7', color: '#000', borderBottomColor: '#000', borderBottomWidth: 1, borderBottomStyle: 'solid', display: 'flex', width: '100%' }}>



                                                    <div style={{ borderRightStyle: 'solid', borderRightColor: '#000', borderRightWidth: 1, padding: 7, textAlign: 'center', width: '23%' }}>
                                                        <span style={{ color: 'red' }}>*</span> 机构性质
                                                        </div>


                                                    <div style={{ borderRightStyle: 'solid', borderRightColor: '#000', borderRightWidth: 1, textAlign: 'center', width: '23%' }}>
                                                        <input value={data.work_nature} type="text" onChange={this._changeValue} name="work_nature" style={{ outline: 'none', border: 0, width: '100%', height: '100%' }} />
                                                    </div>


                                                    <div style={{ borderRightStyle: 'solid', borderRightColor: '#000', borderRightWidth: 1, padding: 7, textAlign: 'center', width: '31%' }}>
                                                        <span style={{ color: 'red' }}>*</span>是否担任法人
                                                        </div>


                                                    <div style={{ textAlign: 'center', width: '23%' }}>
                                                        <input value={data.work_is_lar} type="text" onChange={this._changeValue} name="work_is_lar" style={{ outline: 'none', border: 0, width: '100%', height: '100%' }} />
                                                    </div>



                                                </div>

                                                <div style={{ backgroundColor: '#D7D7D7', color: '#000', borderBottomColor: '#000', borderBottomWidth: 1, borderBottomStyle: 'solid', display: 'flex', width: '100%' }}>



                                                    <div style={{ borderRightStyle: 'solid', borderRightColor: '#000', borderRightWidth: 1, padding: 7, textAlign: 'center', width: '23%' }}>
                                                        <span style={{ color: 'red' }}>*</span>所任岗位/职务
</div>


                                                    <div style={{ borderRightStyle: 'solid', borderRightColor: '#000', borderRightWidth: 1, textAlign: 'center', width: '23%' }}>
                                                        <input value={data.work_position} type="text" onChange={this._changeValue} name="work_position" style={{ outline: 'none', border: 0, width: '100%', height: '100%' }} />
                                                    </div>


                                                    <div style={{ borderRightStyle: 'solid', borderRightColor: '#000', borderRightWidth: 1, padding: 7, textAlign: 'center', width: '31%' }}>
                                                        <span style={{ color: 'red' }}>*</span>入职年限
</div>


                                                    <div style={{ textAlign: 'center', width: '23%' }}>
                                                        <input value={data.entry_years} type="text" onChange={this._changeValue} name="entry_years" style={{ outline: 'none', border: 0, width: '100%', height: '100%' }} />
                                                    </div>



                                                </div>


                                                <div style={{ backgroundColor: '#D7D7D7', color: '#000', borderBottomColor: '#000', borderBottomWidth: 1, borderBottomStyle: 'solid', display: 'flex', width: '100%' }}>



                                                    <div style={{ borderRightStyle: 'solid', borderRightColor: '#000', borderRightWidth: 1, padding: 7, textAlign: 'center', width: '23%' }}>
                                                        专业技术职称
                                                        </div>


                                                    <div style={{ borderRightStyle: 'solid', borderRightColor: '#000', borderRightWidth: 1, textAlign: 'center', width: '23%' }}>
                                                        <input value={data.work_title} type="text" onChange={this._changeValue} name="work_title" style={{ outline: 'none', border: 0, width: '100%', height: '100%' }} />
                                                    </div>


                                                    <div style={{ borderRightStyle: 'solid', borderRightColor: '#000', borderRightWidth: 1, padding: 7, textAlign: 'center', width: '31%' }}>
                                                        <span style={{ color: 'red' }}>*</span>工作年限
                                                        </div>


                                                    <div style={{ textAlign: 'center', width: '23%' }}>
                                                        <input value={data.work_years} type="text" onChange={this._changeValue} name="work_years" style={{ outline: 'none', border: 0, width: '100%', height: '100%' }} />
                                                    </div>



                                                </div>





                                            </div>




                                        </div>

                                    </div>
                                </div>









                                <div id="JPGDOM2" style={{ padding: 80, paddingTop: 100, paddingBottom: 1, border: 1 }}>
                                    <div style={{ width: '100%', height: '85%', borderWidth: 1, borderStyle: 'solid', borderColor: '#000' }}>

                                        {/* 社会专兼职工作及职务 */}
                                        <div style={{ display: 'flex', width: '100%' }}>
                                            <div style={{ width: '15%', backgroundColor: '#D7D7D7', borderBottomColor: '#000', borderBottomWidth: 1, borderBottomStyle: 'solid', textAlign: 'center', borderRightStyle: 'solid', borderRightColor: '#000', borderRightWidth: 1, paddingTop: 5 }}>
                                                <p>社会专兼职工</p>
                                                <p>作及职务</p>
                                            </div>

                                            <div style={{ width: '85%' }}>
                                                <div style={{ backgroundColor: '#D7D7D7', color: '#000', borderBottomColor: '#000', borderBottomWidth: 1, borderBottomStyle: 'solid', display: 'flex', width: '100%' }}>



                                                    <div style={{ borderRightStyle: 'solid', borderRightColor: '#000', borderRightWidth: 1, padding: 7, textAlign: 'center', width: '23%' }}>
                                                        机构名称
                                                            </div>


                                                    <div style={{ borderRightStyle: 'solid', borderRightColor: '#000', borderRightWidth: 1, padding: 7, textAlign: 'center', width: '23%' }}>
                                                        机构性质/领域
                                                            </div>


                                                    <div style={{ borderRightStyle: 'solid', borderRightColor: '#000', borderRightWidth: 1, padding: 7, textAlign: 'center', width: '31%' }}>
                                                        职务
                                                            </div>


                                                    <div style={{ padding: 7, textAlign: 'center', width: '23%' }}>
                                                        加入时间
                                                            </div>




                                                </div>

                                                <div style={{ backgroundColor: '#D7D7D7', color: '#000', borderBottomColor: '#000', borderBottomWidth: 1, borderBottomStyle: 'solid', display: 'flex', width: '100%' }}>



                                                    <div style={{ borderRightStyle: 'solid', borderRightColor: '#000', borderRightWidth: 1, textAlign: 'center', width: '23%' }}>
                                                        <input value={data.work_exper[0].name} type="text" onChange={this._changeValue} name="work_exper" data-num="0" data-sub="name" style={{ outline: 'none', border: 0, width: '100%', height: '100%' }} />
                                                    </div>


                                                    <div style={{ borderRightStyle: 'solid', borderRightColor: '#000', borderRightWidth: 1, textAlign: 'center', width: '23%' }}>
                                                        <input value={data.work_exper[0].nature} type="text" onChange={this._changeValue} name="work_exper" data-num="0" data-sub="nature" style={{ outline: 'none', border: 0, width: '100%', height: '100%' }} />
                                                    </div>


                                                    <div style={{ borderRightStyle: 'solid', borderRightColor: '#000', borderRightWidth: 1, textAlign: 'center', width: '31%' }}>
                                                        <input value={data.work_exper[0].position} type="text" onChange={this._changeValue} name="work_exper" data-num="0" data-sub="position" style={{ outline: 'none', border: 0, width: '100%', height: '100%' }} />
                                                    </div>


                                                    <div style={{ textAlign: 'center', width: '23%' }}>
                                                        <input value={data.work_exper[0].join_time} type="text" onChange={this._changeValue} name="work_exper" data-num="0" data-sub="join_time" style={{ outline: 'none', border: 0, width: '100%', height: '100%' }} />
                                                    </div>



                                                </div>


                                                <div style={{ backgroundColor: '#D7D7D7', color: '#000', borderBottomColor: '#000', borderBottomWidth: 1, borderBottomStyle: 'solid', display: 'flex', width: '100%' }}>



                                                    <div style={{ borderRightStyle: 'solid', borderRightColor: '#000', borderRightWidth: 1, textAlign: 'center', width: '23%' }}>
                                                        <input value={data.work_exper[1].name} type="text" onChange={this._changeValue} name="work_exper" data-num="1" data-sub="name" style={{ outline: 'none', border: 0, width: '100%', height: '100%' }} />
                                                    </div>


                                                    <div style={{ borderRightStyle: 'solid', borderRightColor: '#000', borderRightWidth: 1, textAlign: 'center', width: '23%' }}>
                                                        <input value={data.work_exper[1].nature} type="text" onChange={this._changeValue} name="work_exper" data-num="1" data-sub="nature" style={{ outline: 'none', border: 0, width: '100%', height: '100%' }} />
                                                    </div>


                                                    <div style={{ borderRightStyle: 'solid', borderRightColor: '#000', borderRightWidth: 1, textAlign: 'center', width: '31%' }}>
                                                        <input value={data.work_exper[1].position} type="text" onChange={this._changeValue} name="work_exper" data-num="1" data-sub="position" style={{ outline: 'none', border: 0, width: '100%', height: '100%' }} />
                                                    </div>


                                                    <div style={{ textAlign: 'center', width: '23%' }}>
                                                        <input value={data.work_exper[1].join_time} type="text" onChange={this._changeValue} name="work_exper" data-num="1" data-sub="join_time" style={{ outline: 'none', border: 0, width: '100%', height: '100%' }} />
                                                    </div>





                                                </div>

                                                <div style={{ backgroundColor: '#D7D7D7', color: '#000', borderBottomColor: '#000', borderBottomWidth: 1, borderBottomStyle: 'solid', display: 'flex', width: '100%' }}>



                                                    <div style={{ borderRightStyle: 'solid', borderRightColor: '#000', borderRightWidth: 1, textAlign: 'center', width: '23%' }}>
                                                        <input value={data.work_exper[2].name} type="text" onChange={this._changeValue} name="work_exper" data-num="2" data-sub="name" style={{ outline: 'none', border: 0, width: '100%', height: '100%' }} />
                                                    </div>


                                                    <div style={{ borderRightStyle: 'solid', borderRightColor: '#000', borderRightWidth: 1, textAlign: 'center', width: '23%' }}>
                                                        <input value={data.work_exper[2].nature} type="text" onChange={this._changeValue} name="work_exper" data-num="2" data-sub="nature" style={{ outline: 'none', border: 0, width: '100%', height: '100%' }} />
                                                    </div>


                                                    <div style={{ borderRightStyle: 'solid', borderRightColor: '#000', borderRightWidth: 1, textAlign: 'center', width: '31%' }}>
                                                        <input value={data.work_exper[2].position} type="text" onChange={this._changeValue} name="work_exper" data-num="2" data-sub="position" style={{ outline: 'none', border: 0, width: '100%', height: '100%' }} />
                                                    </div>


                                                    <div style={{ textAlign: 'center', width: '23%' }}>
                                                        <input value={data.work_exper[2].join_time} type="text" onChange={this._changeValue} name="work_exper" data-num="2" data-sub="join_time" style={{ outline: 'none', border: 0, width: '100%', height: '100%' }} />
                                                    </div>

                                                </div>


                                                <div style={{ backgroundColor: '#D7D7D7', color: '#000', borderBottomColor: '#000', borderBottomWidth: 1, borderBottomStyle: 'solid', display: 'flex', width: '100%' }}>



                                                    <div style={{ borderRightStyle: 'solid', borderRightColor: '#000', borderRightWidth: 1, textAlign: 'center', width: '23%' }}>
                                                        <input value={data.work_exper[3].name} type="text" onChange={this._changeValue} name="work_exper" data-num="3" data-sub="name" style={{ outline: 'none', border: 0, width: '100%', height: '100%' }} />
                                                    </div>


                                                    <div style={{ borderRightStyle: 'solid', borderRightColor: '#000', borderRightWidth: 1, textAlign: 'center', width: '23%' }}>
                                                        <input value={data.work_exper[3].nature} type="text" onChange={this._changeValue} name="work_exper" data-num="3" data-sub="nature" style={{ outline: 'none', border: 0, width: '100%', height: '100%' }} />
                                                    </div>


                                                    <div style={{ borderRightStyle: 'solid', borderRightColor: '#000', borderRightWidth: 1, textAlign: 'center', width: '31%' }}>
                                                        <input value={data.work_exper[3].position} type="text" onChange={this._changeValue} name="work_exper" data-num="3" data-sub="position" style={{ outline: 'none', border: 0, width: '100%', height: '100%' }} />
                                                    </div>


                                                    <div style={{ textAlign: 'center', width: '23%' }}>
                                                        <input value={data.work_exper[3].join_time} type="text" onChange={this._changeValue} name="work_exper" data-num="3" data-sub="join_time" style={{ outline: 'none', border: 0, width: '100%', height: '100%' }} />
                                                    </div>

                                                </div>


                                                <div style={{ backgroundColor: '#D7D7D7', color: '#000', borderBottomColor: '#000', borderBottomWidth: 1, borderBottomStyle: 'solid', display: 'flex', width: '100%' }}>



                                                    <div style={{ borderRightStyle: 'solid', borderRightColor: '#000', borderRightWidth: 1, textAlign: 'center', width: '23%' }}>
                                                        <input value={data.work_exper[4].name} type="text" onChange={this._changeValue} name="work_exper" data-num="4" data-sub="name" style={{ outline: 'none', border: 0, width: '100%', height: '100%' }} />
                                                    </div>


                                                    <div style={{ borderRightStyle: 'solid', borderRightColor: '#000', borderRightWidth: 1, textAlign: 'center', width: '23%' }}>
                                                        <input value={data.work_exper[4].nature} type="text" onChange={this._changeValue} name="work_exper" data-num="4" data-sub="nature" style={{ outline: 'none', border: 0, width: '100%', height: '100%' }} />
                                                    </div>


                                                    <div style={{ borderRightStyle: 'solid', borderRightColor: '#000', borderRightWidth: 1, textAlign: 'center', width: '31%' }}>
                                                        <input value={data.work_exper[4].position} type="text" onChange={this._changeValue} name="work_exper" data-num="4" data-sub="position" style={{ outline: 'none', border: 0, width: '100%', height: '100%' }} />
                                                    </div>


                                                    <div style={{ textAlign: 'center', width: '23%' }}>
                                                        <input value={data.work_exper[4].join_time} type="text" onChange={this._changeValue} name="work_exper" data-num="4" data-sub="join_time" style={{ outline: 'none', border: 0, width: '100%', height: '100%' }} />
                                                    </div>

                                                </div>

                                            </div>




                                        </div>
                                        {/* 社会专兼职工作及职务 */}

                                        {/* 获得市级以上表彰奖励 */}
                                        <div style={{ display: 'flex', width: '100%' }}>
                                            <div style={{ width: '15%', backgroundColor: '#D7D7D7', borderBottomColor: '#000', borderBottomWidth: 1, borderBottomStyle: 'solid', textAlign: 'center', borderRightStyle: 'solid', borderRightColor: '#000', borderRightWidth: 1, paddingTop: 5 }}>
                                                <p>获得市级以上</p>
                                                <p>表彰奖励</p>
                                            </div>

                                            <div style={{ width: '85%' }}>
                                                <div style={{ backgroundColor: '#D7D7D7', color: '#000', borderBottomColor: '#000', borderBottomWidth: 1, borderBottomStyle: 'solid', display: 'flex', width: '100%' }}>



                                                    <div style={{ borderRightStyle: 'solid', borderRightColor: '#000', borderRightWidth: 1, padding: 7, textAlign: 'center', width: '40%' }}>
                                                        颁发单位
                                                            </div>


                                                    <div style={{ borderRightStyle: 'solid', borderRightColor: '#000', borderRightWidth: 1, padding: 7, textAlign: 'center', width: '40%' }}>
                                                        荣誉名称
                                                            </div>


                                                    <div style={{ textAlign: 'center', width: '20%' }}>
                                                        获奖年份
                                                            </div>







                                                </div>

                                                <div style={{ backgroundColor: '#D7D7D7', color: '#000', borderBottomColor: '#000', borderBottomWidth: 1, borderBottomStyle: 'solid', display: 'flex', width: '100%' }}>



                                                    <div style={{ borderRightStyle: 'solid', borderRightColor: '#000', borderRightWidth: 1, textAlign: 'center', width: '40%' }}>
                                                        <input value={data.prize[0].unit} type="text" onChange={this._changeValue} name="prize" data-num="0" data-sub="unit" style={{ outline: 'none', border: 0, width: '100%', height: '100%' }} />
                                                    </div>


                                                    <div style={{ borderRightStyle: 'solid', borderRightColor: '#000', borderRightWidth: 1, textAlign: 'center', width: '40%' }}>
                                                        <input value={data.prize[0].name} type="text" onChange={this._changeValue} name="prize" data-num="0" data-sub="name" style={{ outline: 'none', border: 0, width: '100%', height: '100%' }} />
                                                    </div>


                                                    <div style={{ textAlign: 'center', width: '20%' }}>
                                                        <input value={data.prize[0].year} type="text" onChange={this._changeValue} name="prize" data-num="0" data-sub="year" style={{ outline: 'none', border: 0, width: '100%', height: '100%' }} />
                                                    </div>






                                                </div>


                                                <div style={{ backgroundColor: '#D7D7D7', color: '#000', borderBottomColor: '#000', borderBottomWidth: 1, borderBottomStyle: 'solid', display: 'flex', width: '100%' }}>



                                                    <div style={{ borderRightStyle: 'solid', borderRightColor: '#000', borderRightWidth: 1, textAlign: 'center', width: '40%' }}>
                                                        <input value={data.prize[1].unit} type="text" onChange={this._changeValue} name="prize" data-num="1" data-sub="unit" style={{ outline: 'none', border: 0, width: '100%', height: '100%' }} />
                                                    </div>


                                                    <div style={{ borderRightStyle: 'solid', borderRightColor: '#000', borderRightWidth: 1, textAlign: 'center', width: '40%' }}>
                                                        <input value={data.prize[1].name} type="text" onChange={this._changeValue} name="prize" data-num="1" data-sub="name" style={{ outline: 'none', border: 0, width: '100%', height: '100%' }} />
                                                    </div>


                                                    <div style={{ textAlign: 'center', width: '20%' }}>
                                                        <input value={data.prize[1].year} type="text" onChange={this._changeValue} name="prize" data-num="1" data-sub="year" style={{ outline: 'none', border: 0, width: '100%', height: '100%' }} />
                                                    </div>








                                                </div>

                                                <div style={{ backgroundColor: '#D7D7D7', color: '#000', borderBottomColor: '#000', borderBottomWidth: 1, borderBottomStyle: 'solid', display: 'flex', width: '100%' }}>



                                                    <div style={{ borderRightStyle: 'solid', borderRightColor: '#000', borderRightWidth: 1, textAlign: 'center', width: '40%' }}>
                                                        <input value={data.prize[2].unit} type="text" onChange={this._changeValue} name="prize" data-num="2" data-sub="unit" style={{ outline: 'none', border: 0, width: '100%', height: '100%' }} />
                                                    </div>


                                                    <div style={{ borderRightStyle: 'solid', borderRightColor: '#000', borderRightWidth: 1, textAlign: 'center', width: '40%' }}>
                                                        <input value={data.prize[2].name} type="text" onChange={this._changeValue} name="prize" data-num="2" data-sub="name" style={{ outline: 'none', border: 0, width: '100%', height: '100%' }} />
                                                    </div>


                                                    <div style={{ textAlign: 'center', width: '20%' }}>
                                                        <input value={data.prize[2].year} type="text" onChange={this._changeValue} name="prize" data-num="2" data-sub="year" style={{ outline: 'none', border: 0, width: '100%', height: '100%' }} />
                                                    </div>




                                                </div>


                                                <div style={{ backgroundColor: '#D7D7D7', color: '#000', borderBottomColor: '#000', borderBottomWidth: 1, borderBottomStyle: 'solid', display: 'flex', width: '100%' }}>



                                                    <div style={{ borderRightStyle: 'solid', borderRightColor: '#000', borderRightWidth: 1, textAlign: 'center', width: '40%' }}>
                                                        <input value={data.prize[3].unit} type="text" onChange={this._changeValue} name="prize" name="prize" data-num="3" data-sub="unit" style={{ outline: 'none', border: 0, width: '100%', height: '100%' }} />
                                                    </div>


                                                    <div style={{ borderRightStyle: 'solid', borderRightColor: '#000', borderRightWidth: 1, textAlign: 'center', width: '40%' }}>
                                                        <input value={data.prize[3].name} type="text" onChange={this._changeValue} name="prize" name="prize" data-num="3" data-sub="name" style={{ outline: 'none', border: 0, width: '100%', height: '100%' }} />
                                                    </div>


                                                    <div style={{ textAlign: 'center', width: '20%' }}>
                                                        <input value={data.prize[3].year} type="text" onChange={this._changeValue} name="prize" name="prize" data-num="3" data-sub="year" style={{ outline: 'none', border: 0, width: '100%', height: '100%' }} />
                                                    </div>



                                                </div>


                                                <div style={{ backgroundColor: '#D7D7D7', color: '#000', borderBottomColor: '#000', borderBottomWidth: 1, borderBottomStyle: 'solid', display: 'flex', width: '100%' }}>



                                                    <div style={{ borderRightStyle: 'solid', borderRightColor: '#000', borderRightWidth: 1, textAlign: 'center', width: '40%' }}>
                                                        <input value={data.prize[4].unit} type="text" onChange={this._changeValue} name="prize" data-num="4" data-sub="unit" style={{ outline: 'none', border: 0, width: '100%', height: '100%' }} />
                                                    </div>


                                                    <div style={{ borderRightStyle: 'solid', borderRightColor: '#000', borderRightWidth: 1, textAlign: 'center', width: '40%' }}>
                                                        <input value={data.prize[4].name} type="text" onChange={this._changeValue} name="prize" data-num="4" data-sub="name" style={{ outline: 'none', border: 0, width: '100%', height: '100%' }} />
                                                    </div>


                                                    <div style={{ textAlign: 'center', width: '20%' }}>
                                                        <input value={data.prize[4].year} type="text" onChange={this._changeValue} name="prize" data-num="4" data-sub="year" style={{ outline: 'none', border: 0, width: '100%', height: '100%' }} />
                                                    </div>




                                                </div>


                                                <div style={{ backgroundColor: '#D7D7D7', color: '#000', borderBottomColor: '#000', borderBottomWidth: 1, borderBottomStyle: 'solid', display: 'flex', width: '100%' }}>



                                                    <div style={{ borderRightStyle: 'solid', borderRightColor: '#000', borderRightWidth: 1, textAlign: 'center', width: '40%' }}>
                                                        <input value={data.prize[5].unit} type="text" onChange={this._changeValue} name="prize" data-num="5" data-sub="unit" style={{ outline: 'none', border: 0, width: '100%', height: '100%' }} />
                                                    </div>


                                                    <div style={{ borderRightStyle: 'solid', borderRightColor: '#000', borderRightWidth: 1, textAlign: 'center', width: '40%' }}>
                                                        <input value={data.prize[5].name} type="text" onChange={this._changeValue} name="prize" data-num="5" data-sub="name" style={{ outline: 'none', border: 0, width: '100%', height: '100%' }} />
                                                    </div>


                                                    <div style={{ textAlign: 'center', width: '20%' }}>
                                                        <input value={data.prize[5].year} type="text" onChange={this._changeValue} name="prize" data-num="5" data-sub="year" style={{ outline: 'none', border: 0, width: '100%', height: '100%' }} />
                                                    </div>




                                                </div>

                                            </div>




                                        </div>
                                        {/* 获得市级以上表彰奖励 */}


                                        {/* 获得市级以上表彰奖励 */}
                                        <div style={{ display: 'flex', width: '100%' }}>
                                            <div style={{ width: '15%', backgroundColor: '#D7D7D7', borderBottomColor: '#000', borderBottomWidth: 1, borderBottomStyle: 'solid', textAlign: 'center', borderRightStyle: 'solid', borderRightColor: '#000', borderRightWidth: 1, }}>
                                                <p style={{ color: 'red' }}>*</p>
                                                <p>个人专业技术</p>
                                                <p>资格、技能、</p>
                                                <p>专业培训</p>
                                            </div>

                                            <div style={{ width: '85%', borderBottomColor: '#000', borderBottomWidth: 1, borderBottomStyle: 'solid', }}>
                                                <textarea name="" id="" rows="10" style={{ outline: 'none', border: 0, width: '100%', height: '100%', resize: 'none' }} onChange={this._changeValue} name="skill" value={data.skill}></textarea>
                                            </div>


                                        </div>
                                        {/* 获得市级以上表彰奖励 */}




                                        {/* 标题 */}
                                        <div style={{ textAlign: 'center', backgroundColor: '#D7D7D7', color: '#000', padding: 7, borderBottomStyle: 'solid', borderBottomColor: '#000', borderBottomWidth: 1 }}>身份证扫描件/复印件</div>
                                        {/* 标题 */}


                                        <div style={{ display: 'flex', width: '100%' }}>
                                            <div style={{ width: '50%', borderBottomColor: '#000', borderBottomWidth: 1, borderBottomStyle: 'solid', borderRightStyle: 'solid', borderRightColor: '#000', borderRightWidth: 1, textAlign: 'center', height: 350 }}>
                                                <p style={{ color: 'red' }}>*</p>
                                                <p>正面</p>
                                            </div>

                                            <div style={{ width: '50%', borderBottomColor: '#000', borderBottomWidth: 1, borderBottomStyle: 'solid', textAlign: 'center', height: 350 }}>
                                                <p style={{ color: 'red' }}>*</p>
                                                <p>反面</p>
                                            </div>


                                        </div>
                                    </div>



                                    <div style={{ width: '100%' }}>
                                        <p style={{ textIndent: '30em' }}>签字：<span style={{ color: '#ccc', fontSize: 16 }}>签名加盖手指印</span></p>
                                        <p style={{ textIndent: '30em', display: 'flex' }}>日期：&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;年&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;月&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;日</p>
                                    </div>

                                    <div style={{ padding: 50, textAlign: 'center' }}>

                                        备注：本表为存心救援授权使用方管理团队主要成员填写，提交后需自行下载打印并<span style={{color:'red'}}>粘贴个人证件照片和身份证正反面复印件</span>，将本文件<span style={{color:'red'}}>打印版签字加盖手指印</span>后拍照上传。

                                        </div>

                                </div>
















                            </div>
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                            <Button style={{ width: 200, backgroundColor: '#1890FF', color: '#fff', marginRight: 40 }} onClick={this.submit}>提交</Button>
                            <Button style={{ width: 200 }} onClick={this.ShutDownFill}>关闭</Button>
                            <div onClick={this.downloadJPG}></div>
                        </div>
                    </Modal>



                </div>
            </div>



        )
    }
}



export default PersonalInformation



// WEBPACK FOOTER //
// ./src/routes/teamApplication/PreparatoryTeamApplicationDirectory/UploadInformationModal/PersonalInformation.jsx